let hostname = `${window.location.protocol}//${window.location.host}/`;

const awsmobile = {
  Auth: {
    region: process.env.VUE_APP_AWS_REGION,
    userPoolId: process.env.VUE_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_USER_POOL_CLIENT_ID,
    // aws_user_pools_mfa_type: 'OFF',
    // OPTIONAL - Hosted UI configuration
    oauth: {
      domain: "auth.schindelhauerbikes.com",
      scope: [
        "phone",
        "email",
        "profile",
        "openid",
        "aws.cognito.signin.user.admin",
      ],
      redirectSignIn: hostname,
      redirectSignOut: `${hostname}`,
      responseType: "code", // or 'token', note that REFRESH token will only be generated when the responseType is code
    },
  },
};

export default awsmobile;
